// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type AccountsHoldingsData } from '../../interfaces/api/brokerage/brokerage';

export const HOLDING_ASSET_TYPE_MAP = {
  equity: 'stock',
  etf: 'etf',
  'mutual fund': 'mutual_fund',
  stock: 'stock',
  fund: 'mutual_fund',
  'pension-plan': 'mutual_fund',
  'pension-plans': 'mutual_fund',
  eu_pension_plans: 'mutual_fund',
  us_pension_plans: 'mutual_fund',
} as const;

export const buildAggregatorAccountTagManagerPositions = (
  data: AccountsHoldingsData[],
): AccountsHoldingsData[] => {
  return [];
};
